module.exports = __webpack_public_path__ + "images/11901db5d80a793a04c559a92f214ab3.svg";